import { ReactNode } from 'react';
import { useAppSelector } from '@hooks/reduxHooks';

import { RootState } from './store';

interface IProps<T> {
  children: (state: T) => ReactNode;
  selector: (state: RootState) => T;
}

export const State = <T, _>({ children, selector }: IProps<T>) => {
  const state = useAppSelector(selector);

  return children(state);
};
